import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'

function SkeletonRevenueTracker(){
    return <div className="card border-0 text-truncate mb-3">
        <div className="card-body">
            <div className="row d-flex justify-content-between" style={{height:"30px"}}>
                <div className="col-sm-6 col mb-1 f-s-16">
                    <b className="mb-3"><Skeleton width={200} /></b> 
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-xl-4 col-lg-6 col-sm-6 mb-3 mb-sm-0 mb-lg-0">
                    <h2 className={`mb-0 font-weight-bold`} data-animation="number">
                        <Skeleton width={100} height={40} />
                    </h2>
                </div>
                <div className="col-xl-4 col-lg-6 col-sm-6 mb-3 mb-sm-0 mb-lg-0">
                    <h3 class="m-b-0 font-weight-bold" data-animation="number">
                        <Skeleton width={100} height={40} />
                    </h3>
                </div>
                <div className="col-xl-4 mt-sm-3 text-right">
                    <Link id="scoreCardBtn" to="/score-card" className="btn btn-primary btn-sm mb-xl-2 mr-2 mr-sm-2 mr-xl-0" style={{width: "10em"}}>
                        View Score Card
                    </Link>
                    <br className="d-none d-sm-none d-lg-none d-xl-block" />
                    <Link to={"/unit-sales-entry"} className="btn btn-primary btn-sm" style={{width: "10em"}}>
                        Set Goals
                    </Link>
                </div>
            </div>
        </div>
    </div>
}

export default SkeletonRevenueTracker